import React from 'react';
import './SharedActions.css';
export default function BackButton({children,href,onClick,label}) {
  const props={className:'hq-back-button',onClick,'aria-label':label};
  return href ? <a {...props} data-shq-return href={href}>← {children}</a> : <button {...props} type="button">← {children}</button>;
}
